var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},_vm._l((_vm.jdrList),function(name){return _c('JdrComponent',{key:name,attrs:{"id":name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }